import { getName } from './getName';
import { findFieldByType } from './findFieldByType';
import getValidCountryCode from './getValidCountryCode';

const getBilling = fields => {
  const billing = {
    name: getName(fields),
    companyName: findFieldByType(fields, 'company-name')?.value || '',
    email: findFieldByType(fields, 'email')?.value?.toLowerCase() || '',
    billingEmail: findFieldByType(fields, 'billing-email')?.value?.toLowerCase() || '',
    phone: findFieldByType(fields, 'phone')?.value || '',
    address: {
      line1: findFieldByType(fields, 'address-line1')?.value || '',
      line2: findFieldByType(fields, 'address-line2')?.value || '',
      city: findFieldByType(fields, 'address-city')?.value || '',
      state: findFieldByType(fields, 'address-state')?.value || '',
      postalCode: findFieldByType(fields, 'address-postal_code')?.value || '',
      country: findFieldByType(fields, 'address-country')?.value || '',
    },
  };

  return billing;
};

const getStripeBilling = fields => {
  const billing = getBilling(fields);

  const stripeBilling = {
    name: billing.companyName || billing.name,
    phone: billing.phone,
    address: {
      line1: billing.address.line1,
      line2: billing.address.line2,
      city: billing.address.city,
      state: billing.address.state,
      postal_code: billing.address.postalCode,
      country: billing.address.country,
    },
  };

  return stripeBilling;
};

const getShipping = fields => {
  const shippingName = findFieldByType(fields, 'shipping-name')?.value || '';
  const shippingPhone = findFieldByType(fields, 'shipping-phone')?.value || '';

  const shipping = {
    name: shippingName || getName(fields),
    phone: shippingPhone || findFieldByType(fields, 'phone')?.value || '',
    address: {
      line1: findFieldByType(fields, 'shipping-address-line1')?.value || '',
      line2: findFieldByType(fields, 'shipping-address-line2')?.value || '',
      city: findFieldByType(fields, 'shipping-address-city')?.value || '',
      state: findFieldByType(fields, 'shipping-address-state')?.value || '',
      postalCode: findFieldByType(fields, 'shipping-address-postal_code')?.value || '',
      country: findFieldByType(fields, 'shipping-address-country')?.value || '',
    },
  };

  return shipping;
};

const getStripeShipping = fields => {
  const shipping = getShipping(fields);

  const stripeShipping = {
    name: shipping.name,
    phone: shipping.phone,
    address: {
      line1: shipping.address.line1,
      line2: shipping.address.line2,
      city: shipping.address.city,
      state: shipping.address.state,
      postal_code: shipping.address.postalCode,
      country: shipping.address.country,
    },
  };

  return stripeShipping;
};

function getAddress(billing, shipping) {
  const address = {};

  if (billing.address.line1) {
    address.line1 = billing.address.line1;
  } else if (shipping.address.line1) {
    address.line1 = shipping.address.line1;
  }

  if (billing.address.line2) {
    address.line2 = billing.address.line2;
  } else if (shipping.address.line2) {
    address.line2 = shipping.address.line2;
  }

  if (billing.address.city) {
    address.city = billing.address.city;
  } else if (shipping.address.city) {
    address.city = shipping.address.city;
  }

  if (billing.address.state) {
    address.state = billing.address.state;
  } else if (shipping.address.state) {
    address.state = shipping.address.state;
  }

  if (billing.address.postal_code) {
    address.postal_code = billing.address.postal_code;
  } else if (shipping.address.postal_code) {
    address.postal_code = shipping.address.postal_code;
  }

  if (billing.address.country) {
    address.country = billing.address.country;
  } else if (shipping.address.country) {
    address.country = shipping.address.country;
  }

  if (address.country) {
    const countryCode = getValidCountryCode(address.country);

    if (countryCode) {
      address.country = countryCode;
    } else {
      delete address.country;
    }
  }

  if (Object.keys(address).length === 0) {
    return null;
  }

  return address;
}

export default function getBillingDetailsFromFields(fields) {
  if (!fields) {
    return {};
  }

  const email = findFieldByType(fields, 'email')?.value?.toLowerCase() || '';
  const billingEmail = findFieldByType(fields, 'billing-email')?.value?.toLowerCase() || '';

  const stripeBilling = getStripeBilling(fields);
  const stripeShipping = getStripeShipping(fields);
  const stripeAddress = getAddress(stripeBilling, stripeShipping);

  const billingDetails = {
    email: billingEmail || email,
    name: stripeBilling.name,
    ...(stripeBilling.phone && { phone: stripeBilling.phone }),
    ...(stripeAddress && { address: stripeAddress }),
  };

  return billingDetails;
}
